import { render, staticRenderFns } from "./OrderGroup.vue?vue&type=template&id=3c1e3ef4&scoped=true&"
import script from "./OrderGroup.vue?vue&type=script&lang=js&"
export * from "./OrderGroup.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroup.vue?vue&type=style&index=0&id=3c1e3ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e3ef4",
  null
  
)

export default component.exports